import apiService from './api';
class OrcamentoNotificationsService {
    // Listar notificações de orçamentos aprovados
    async listarAprovados() {
        try {
            const response = await apiService.get('/orcamento-notifications/aprovados');
            return response.data?.data || [];
        }
        catch (error) {
            console.error('Erro ao listar notificações de orçamentos aprovados:', error);
            return [];
        }
    }
    // Listar notificações de orçamentos rejeitados
    async listarRejeitados() {
        try {
            const response = await apiService.get('/orcamento-notifications/rejeitados');
            return response.data?.data || [];
        }
        catch (error) {
            console.error('Erro ao listar notificações de orçamentos rejeitados:', error);
            return [];
        }
    }
    // Contar notificações não lidas de orçamentos aprovados
    async contarNaoLidasAprovados() {
        try {
            const response = await apiService.get('/orcamento-notifications/aprovados/count');
            return response.data?.count || 0;
        }
        catch (error) {
            console.error('Erro ao contar notificações não lidas de aprovados:', error);
            return 0;
        }
    }
    // Contar notificações não lidas de orçamentos rejeitados
    async contarNaoLidasRejeitados() {
        try {
            const response = await apiService.get('/orcamento-notifications/rejeitados/count');
            return response.data?.count || 0;
        }
        catch (error) {
            console.error('Erro ao contar notificações não lidas de rejeitados:', error);
            return 0;
        }
    }
    // Marcar notificação como lida
    async marcarComoLida(id) {
        try {
            await apiService.put(`/orcamento-notifications/${id}/lida`);
        }
        catch (error) {
            console.error('Erro ao marcar notificação como lida:', error);
        }
    }
}
export default new OrcamentoNotificationsService();
